// Shopify Wishlist Button State Monitor
// Add this to your theme.liquid, product.liquid, or as a separate JS file

(function() {
    'use strict';
    
    // Configuration
    const CONFIG = {
        buttonSelector: 'ap-wishlistbutton', // Your button element
        activeClass: 'active',
        alertDuration: 3000, // 3 seconds
        messages: {
            added: 'Item added to wishlist! ❤️',
            removed: 'Item removed from wishlist! 💔'
        }
    };
    
    // Create alert element dynamically
    function createAlertElement() {
        const alert = document.createElement('div');
        alert.id = 'wishlist-alert';
        alert.style.cssText = `
            position: fixed;
            top: 20px;
            right: 20px;
            background: #4CAF50;
            color: white;
            padding: 15px 20px;
            border-radius: 6px;
            box-shadow: 0 4px 12px rgba(0,0,0,0.2);
            transform: translateX(400px);
            transition: transform 0.3s ease;
            z-index: 9999;
            font-family: Arial, sans-serif;
            font-size: 14px;
            max-width: 300px;
        `;
        document.body.appendChild(alert);
        return alert;
    }
    
    // Show alert message
    function showAlert(message, type = 'success') {
        let alertElement = document.getElementById('wishlist-alert');
        if (!alertElement) {
            alertElement = createAlertElement();
        }
        
        // Set background color based on type
        alertElement.style.background = type === 'success' ? '#4CAF50' : '#f44336';
        alertElement.textContent = message;
        
        // Show alert
        alertElement.style.transform = 'translateX(0)';
        
        // Hide after duration
        setTimeout(() => {
            alertElement.style.transform = 'translateX(400px)';
        }, CONFIG.alertDuration);
    }
    
    // Monitor single button
    function monitorWishlistButton(button) {
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                    const hasActive = button.classList.contains(CONFIG.activeClass);
                    const previouslyActive = mutation.oldValue ? 
                        mutation.oldValue.includes(CONFIG.activeClass) : false;
                    
                    // Button changed from inactive to active (add → remove)
                    if (hasActive && !previouslyActive) {
                        showAlert(CONFIG.messages.added, 'success');
                        
                        // Optional: Trigger custom event
                        button.dispatchEvent(new CustomEvent('wishlistAdded', {
                            detail: { productId: button.getAttribute('data-id') }
                        }));
                    }
                    // Button changed from active to inactive (remove → add)
                    else if (!hasActive && previouslyActive) {
                        showAlert(CONFIG.messages.removed, 'error');
                        
                        // Optional: Trigger custom event
                        button.dispatchEvent(new CustomEvent('wishlistRemoved', {
                            detail: { productId: button.getAttribute('data-id') }
                        }));
                    }
                }
            });
        });
        
        // Start observing
        observer.observe(button, {
            attributes: true,
            attributeOldValue: true,
            attributeFilter: ['class']
        });
    }
    
    // Initialize monitoring for all existing buttons
    function initWishlistMonitoring() {
        const buttons = document.querySelectorAll(CONFIG.buttonSelector);
        buttons.forEach(button => {
            monitorWishlistButton(button);
        });
    }
    
    // Monitor for new buttons added to DOM (for AJAX loaded content)
    function observeNewButtons() {
        const bodyObserver = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                mutation.addedNodes.forEach((node) => {
                    if (node.nodeType === 1) { // Element node
                        // Check if the added node is a wishlist button
                        if (node.matches && node.matches(CONFIG.buttonSelector)) {
                            monitorWishlistButton(node);
                        }
                        // Check if the added node contains wishlist buttons
                        const newButtons = node.querySelectorAll ? 
                            node.querySelectorAll(CONFIG.buttonSelector) : [];
                        newButtons.forEach(button => {
                            monitorWishlistButton(button);
                        });
                    }
                });
            });
        });
        
        bodyObserver.observe(document.body, {
            childList: true,
            subtree: true
        });
    }
    
    // Wait for DOM to be ready
    function ready(fn) {
        if (document.readyState !== 'loading') {
            fn();
        } else {
            document.addEventListener('DOMContentLoaded', fn);
        }
    }
    
    // Initialize everything
    ready(function() {
        initWishlistMonitoring();
        observeNewButtons();
        
        // Optional: Listen for custom events
        document.addEventListener('wishlistAdded', function(e) {
            console.log('Product added to wishlist:', e.detail.productId);
            // Add any additional logic here (analytics, etc.)
        });
        
        document.addEventListener('wishlistRemoved', function(e) {
            console.log('Product removed from wishlist:', e.detail.productId);
            // Add any additional logic here (analytics, etc.)
        });
    });
    
    // Expose utility functions globally if needed
    window.WishlistMonitor = {
        showAlert: showAlert,
        config: CONFIG
    };
})();

/* 
USAGE INSTRUCTIONS FOR SHOPIFY:

1. METHOD 1 - Add to theme.liquid:
   Add this script before </body> tag in theme.liquid:
   <script>
   // Paste the above code here
   </script>

2. METHOD 2 - Create separate JS file:
   - Go to Assets folder in theme editor
   - Create new file: wishlist-monitor.js
   - Paste the code there
   - Include in theme.liquid: {{ 'wishlist-monitor.js' | asset_url | script_tag }}

3. METHOD 3 - Add to existing theme JS file:
   Add this code to your existing theme.js or main.js file

4. CUSTOMIZATION:
   - Change buttonSelector if your button has different selector
   - Modify messages in CONFIG object
   - Adjust alert styling in createAlertElement function
   - Change alertDuration for longer/shorter display

5. FOR PRODUCT PAGES ONLY:
   Wrap the initialization in:
   if (window.location.pathname.includes('/products/')) {
       // Initialize code here
   }
*/